import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "../components/Reveal";
import { CONTACT } from "../data/experiences";

const SECTIONS = [
  {
    id: "cancellation",
    title: "Cancellation & Refund Policy",
    body: "Cancellations made 45 days or more before travel receive a full refund minus non-recoverable costs such as palace buyouts or train allocations. Cancellations 44 to 21 days before travel receive a 50% refund. Within 21 days, refunds depend on hotel and supplier policies, and we will always recover whatever we can on your behalf. Any non-refundable deposit is stated clearly before you pay it.",
  },
  {
    id: "safety",
    title: "Safety & Emergency Policy",
    body: "Every group travels with licensed guides, vetted transport and a documented risk assessment. We maintain 24/7 on-ground support, share emergency protocols with faculty and group leaders before departure, and carry first-aid trained staff on all educational programmes.",
  },
];

export default function Legal() {
  return (
    <main data-testid="legal-page" className="bg-ivory">
      <section className="pt-40 pb-16 bg-obsidian text-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="font-accent text-xs tracking-[0.4em] text-gold mb-6">LEGAL</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl" data-testid="legal-headline">Policies, plainly written.</h1>
          <p className="mt-6 text-[#B5A7A9] text-sm">
            Also read our <Link data-testid="legal-privacy-link" to="/privacy" className="text-gold hover:text-gold-light underline underline-offset-4">Privacy Policy</Link> and <Link data-testid="legal-terms-link" to="/terms" className="text-gold hover:text-gold-light underline underline-offset-4">Terms & Conditions</Link>.
          </p>
        </div>
      </section>
      <section className="py-20 sm:py-28">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-16">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.id}>
              <section id={s.id} data-testid={`legal-${s.id}`}>
                <Eyebrow>{String(i + 1).padStart(2, "0")}</Eyebrow>
                <h2 className="mt-3 font-serif text-3xl text-maroon mb-5">{s.title}</h2>
                <p className="text-[#5C4F52] text-base leading-relaxed">{s.body}</p>
              </section>
            </Reveal>
          ))}
          <Reveal>
            <p className="text-sm text-[#5C4F52]/70 border-t border-gold/25 pt-8">
              Questions about these policies? Write to {CONTACT.email}. {CONTACT.company}, New Delhi.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
